<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'account' | lang }}</div>
    </header>
    <div v-if="user">
 

      <profileimage style="margin: auto;"></profileimage>

      <div style="text-align: center;" class="buttons-grp">
        <button @click="changeEmailAddress" :disabled="!isConnected">{{ 'ChangeEmailButton' | lang }}</button>
        <button @click="goTo('/changepassword')" :disabled="!isConnected">{{ 'changePassword' | lang }}</button>
        <button @click="logout">{{ 'logout' | lang }}</button>
      </div>
      
      <template v-if="tessereComputed">
        <div class="jsfixedheader">{{ 'Email' | lang }}</div>
        <!-- <div class="floating-label">
          <input v-model="user.UserAccountCode" placeholder=" " type="text" disabled />
          <label>{{ 'LoginEmail' | lang }}</label>
        </div> -->
        <div class="floating-label">
          <input v-model="user.Email" placeholder=" " type="text" disabled />
          <label>{{ 'Email' | lang }}</label>
        </div>
        <!--<h3>Le mie tessere</h3>-->
        <div class="jsfixedheader">{{ 'Mycards' | lang }}</div>
        <ul class="results arrow" v-if="(isMobile || true) && tessereComputed && tessereComputed.length>0">
          <li v-for="(c, idx) in tessereComputed" :key="idx" @click="goTo('/account/csc/' + c.MediaSerialNumber)">
            <div class="title">{{ 'CSCnr' | lang }} {{c.MediaSerialNumber}}</div>
            <div class="subtitle" v-if="c.humanExpirationDate">{{ 'ExpirationDate' | lang }} {{c.humanExpirationDate}}</div>
            <div class="subtitle" v-else>{{ 'ExpirationDateUnknown' | lang }}</div>
          </li>
        </ul>
        <div v-else>
         <!-- <csc-contracts :carddata="csc" v-for="(csc, idx) in tessereComputed" :key="idx" />-->
         <div style="padding: 8px;margin-top:15px;margin-bottom: 15px;">{{ 'MycardsEmpty' | lang }}</div>
        </div>
      </template>
    
      <div v-if="manifest.manageRelativeUser==true"> 
      <button v-if="isMobile" @click="goTo('/account/relativeusers')" :disabled="!isConnected">{{ 'RelativeUsers' | lang }}</button>
      <template v-else>
        <div class="jsfixedheader">{{ 'RelativeUsers' | lang }}</div>
        <relativeusers />
      </template>
    </div>
  
      <button v-if="isMobile" @click="goTo('/account/anagrafica/true',false)" :disabled="!isConnected">{{ 'Profile' | lang }}</button>
      <template v-else>
        <!-- <h3>{{ 'My_data' | lang }}</h3> -->
        <div class="jsfixedheader">{{ 'Profile' | lang }}</div>
        <anagrafica :onlyread=onlyRead />
      </template>
  
    
      <button v-if="isMobile" @click="goTo('/account/addresses/0')" :disabled="!isConnected">{{ 'Addresses' | lang }}</button>
      <template v-else>
        <div class="jsfixedheader">{{ 'Addresses' | lang }}</div>
        <addresss :idx="0" />
      </template>


      <button v-if="isMobile" @click="goTo('/account/purchases')" :disabled="!isConnected">{{ 'PurchasesHistory' | lang }}</button>
      <template v-else>
        <!-- <h3>{{'PurchasesHistory' | lang}}</h3> -->
        <div class="jsfixedheader">{{ 'PurchasesHistory' | lang }}</div>
        <storicoacquisti />
      </template>


      <!--<div v-if="!isMobile" class="jsfixedheader">{{ 'Actions' | lang }}</div>-->
   
    </div>
    <div v-else>&nbsp;</div>
    <!-- <footer>
      <button @click="logout">{{ 'logout' | lang }}</button>
    </footer> -->
  </div>
</template>

<script>
import moment from 'moment'
import page from '@/mixins/routeControl'
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'
// import csc from '@/components/CSC.vue'
// import cscContracts from '@/components/CSCcontracts.vue'
import profileimage from '@/components/ProfileImage.vue'
import anagrafica from '@/components/Anagrafica.vue'
import storicoacquisti from '@/components/StoricoAcquisti.vue'
import relativeusers from '@/components/RelativeUsers.vue'
import ChangeEmailAddress from '@/dialogs/ChangeEmailAddress'
import addresss from '@/components/Address.vue'

import { create } from 'vue-modal-dialogs'
import SimpleDialog from '@/dialogs/SimpleDialog'

const simpleDialogCreator = create(SimpleDialog)
const ChangeEmailAddressDialogCreator = create(ChangeEmailAddress)

export default {
  name: 'Account',
  mixins: [ page, databaseWrapperMixin ],
  components: { /* csc, cscContracts, */ anagrafica, storicoacquisti, addresss,profileimage,relativeusers },
  data () {
    return {
      onlyRead:true
    }
  },
  computed: {
    tessereComputed () {
      if (this.userProfile && this.userProfile.tessere) {
        return this.userProfile.tessere.filter(t => t.MediaUnicity != 0).map(t => {
          return { ...t, humanExpirationDate: t.ExpirationDate ? moment(t.ExpirationDate).format('DD/MM/YYYY') : null }
        })
      }
      return null
    }
  },
  methods: {
    async changeEmailAddress () {
      let newAddress = await ChangeEmailAddressDialogCreator()
      if (newAddress) {
        this._askMailUpdate(newAddress).then(() => {
          simpleDialogCreator({
            text: this.dictValue('ChangeMailDoSecondStep'),
            faicon: 'fa-envelope-o',
            cancelLabel: null
          }).then(() => {
            this.goTo('/', true, true)
          })
        })
      }
    }
  },
  beforeDestroy () {},
  mounted () {},
  watch: {}
}
</script>

<style lang="scss">

#app.default .csc-list {
  // display: flex;
  // flex-direction: column;

  & > * {
    margin: 1rem;
    display: flex;
    flex-direction: row;
  }
}

#app.small .csc-list {
  // display: flex;
  // flex-direction: column;
  // flex-wrap: wrap;

  & > * {
    margin-top: 1rem;

    &:nth-child(1) {
      margin-top: 0;
    }
  }
}

</style>
